import React from 'react'
import {
    Row, Col, Button, notification, Tabs,
} from 'antd'
import API from '../../services/API'
import { useDebounce} from 'usehooks-ts'
import Segment from '../../components/Segment'
import PanelRelations from './PanelRelations'
import PanelGeneralData from './PanelGeneralData'
import PanelPrices from './PanelPrices'
import PanelImages from './PanelImages'

const { TabPane } = Tabs

const INIT = {
    name: '',
    description: '',
    active: true,
    sat_code: '',
    slug: '',
    barcode: '',
    min_supply: '',
    sku: '',
    in_stock: null,
    cost: 0,
    base_price: 0,
    //Prices
    franquicia: 0,
    mayoreo: 0,
    mediomayoreo: 0,
    //relationships
    brand_id: null,
    product_type_id: null,
    currency_id: null,
    measure_unit_id: null,
    tax_type_id: 0,
    tax_type_second_id: 0,
    cost_without_freight: 0,
    freight: 0,
    general: 0,
    sat_code_item:null,
    sat_unit_code: '',
    sat_unit_code_item: null,
    sat_unit_code_id: null

}

const ProductsEditContainer = props => {
    const { match } = props
    const [data, setData] = React.useState(INIT)
    const [prices, setPrices] = React.useState([])
    const [images, setImages] = React.useState([])
    const [currentDataProductDesc, setCurrentDataProductDesc] = React.useState([])
    const [currentDataProductAsc, setCurrentDataProductAsc] = React.useState([])
    const debouncedSatCode= useDebounce(data.sat_code,800);
    const debouncedSatUnitCode = useDebounce(data.sat_unit_code, 800);

    const [loading, setloading] = React.useState(false)

    const mapImages = (rawImages, defaultImage) => rawImages.map(item => {
        return {
            uid: item.id,
            url: item.thumbnail_path,
            fullUrl: item.path,
            isMain: !!defaultImage && item.path === defaultImage,
        }
    })

    const refreshImages = async id => {
        try {
            const response = await API.get(`/api/products/${id}`)
            if (response.data) {
                setImages(mapImages(response.data.images || [], response.data.default_image))
            }
        } catch (error) {
            console.error(error)
        }
    }

    const getData = () => {
        setloading(true)
        API.get(`/api/products/${match.params.id}?include[]=prices,productsAsc.parent,productsDesc.product`)
            .then(response => {
                setloading(false)
                if (response.data) {
                    setData(response.data)

                    if (response.data.sat_unit_code_item) {
                        handleChange('sat_unit_code', response.data.sat_unit_code_item.key)
                    }

                    if (response.data.prices) {
                        console.log('response.data.prices: ', response.data.prices);
                        setPrices(response.data.prices)
                    }

                    if (response.data.products_desc) {
                        const newProductaDesc = response.data.products_desc.map(item => {
                            return {
                                key: item.product.id,
                                name: item.product.name,
                                sku: item.product.sku,
                                amount: item.amount,
                            }
                        })
                        setCurrentDataProductDesc(newProductaDesc)
                    }

                    if (response.data.products_asc) {
                        const newProductaAsc = response.data.products_asc.map(item => {
                            return {
                                key: item.parent.id,
                                sku: item.parent.sku,
                                name: item.parent.name,
                                amount: item.amount,
                            }
                        })
                        setCurrentDataProductAsc(newProductaAsc)
                    }

                    if (response.data.images) {
                        setImages(mapImages(response.data.images, response.data.default_image))
                    }
                }
            })
            .catch(error => {
                console.error(error)
                setloading(false)
            })
    }

    React.useEffect(() => {
        getData()
    }, [])

    React.useEffect(() => {
        console.log('prices changed: ', prices)
    }, [prices]);

    React.useEffect(() => {
        if(data.sat_code && data.sat_code !== '' && data.sat_code.length >= 6 && data.sat_code.length <= 8){
            getDescriptionSat(data.sat_code);
         }
    }, [debouncedSatCode]);

    React.useEffect(() => {
        if (data.sat_unit_code && data.sat_unit_code.length >= 2) {
            getSatUnitCode(data.sat_unit_code);
        }
    }, [debouncedSatUnitCode]);


    const handleSaveImages = async id => {
        const toUpload = images.filter(img => !img.markedForDeletion && !Number.isInteger(img.uid))
        const toDelete = images.filter(img => img.markedForDeletion && Number.isInteger(img.uid))
        const mainCandidate = images.find(img => !img.markedForDeletion && img.isMain)

        try {
            const uploaded = await Promise.all(
                toUpload.map(image => {
                    const formData = new FormData()
                    formData.append('image', image.originFileObj)
                    return API.post(`/api/products/${id}/images`, formData, {
                        headers: { 'Content-Type': 'multipart/form-data' },
                    }).then(response => ({ localUid: image.uid, id: response.data.id }))
                })
            )

            if (mainCandidate) {
                const mainId = Number.isInteger(mainCandidate.uid)
                    ? mainCandidate.uid
                    : (uploaded.find(u => u.localUid === mainCandidate.uid) || {}).id

                if (mainId) {
                    await API.patch(`/api/products/images/${mainId}/main`)
                }
            }

            await Promise.all(toDelete.map(image => API.delete(`/api/products/images/${image.uid}`)))
        } catch (error) {
            notification.error({
                message: 'Ha ocurrido un error al guardar las imágenes',
            })
        } finally {
            await refreshImages(id)
        }
    }

    // const handleChange = (name, value) => {
    //     const newData = { ...data }
    //     newData[name] = value
    //     setData(newData)
    // }
    //
    //Persitencia al modifcar dos inputs al mismo tiempo
    const handleChange = (name, value) => {
        setData(prevData => {
            const newData = { ...prevData };
            newData[name] = value;
            return newData;
        });
    }
    const handleSubmit = async () => {
        setloading(true)
        if (!data.brand_id) {
            notification.error({
                message: 'La marca es requerida',
            })
            setloading(false)
            return
        }
        const newData = {
            ...data,
            prices,
            productsAsc: currentDataProductAsc,
            productsDesc: currentDataProductDesc,
            _method: 'PUT',
        }

        try {
            const response = await API.post(`/api/products/${match.params.id}`, newData)

            if (response.data) {
                await handleSaveImages(response.data.id)
                notification.success({
                    message: 'El producto se ha editado exitosamente',
                })
            }
        } catch (error) {
            if (error.response && error.response.data && error.response.data.message) {
                notification.error({
                    message: error.response.data.message[0],
                })
            }
        } finally {
            setloading(false)
        }
    }

    const getDescriptionSat = (sat_code) => {
        setloading(true)
        API.get(`/api/sat_code?filter[code]=${sat_code}&pagination=false&first=true`)
            .then(response => {
                setloading(false)
                if (response.data) {
                    handleChange("sat_code_item", response.data);
                  }
            })
            .catch(error => {
                setloading(false)
                notification.error({ message: error.message })
            })
    }

    const getSatUnitCode = (key) => {
        setloading(true)
        API.get(`/api/sat_unit_code?filter[key]=${key}&pagination=false&first=true`)
            .then(response => {
                setloading(false)
                if (response.data) {
                    handleChange('sat_unit_code_item', response.data);
                    handleChange('sat_unit_code_id', response.data.id);
                }
            })
            .catch(error => {
                setloading(false)
                notification.error({ message: error.message })
            })
    }

    return (
        <Segment loading={loading}>
            <Tabs defaultActiveKey="1">
                <TabPane tab="Información general" key="1">
                    <PanelGeneralData data={data} change={handleChange} />
                </TabPane>
                <TabPane tab="Relaciones" key="2">
                    <PanelRelations
                        desc={currentDataProductDesc}
                        setDesc={setCurrentDataProductDesc}
                        asc={currentDataProductAsc}
                        setAsc={setCurrentDataProductAsc}
                        data={data}
                    />
                </TabPane>
                <TabPane tab="Ajuste de precios" key="3">
                    <PanelPrices
                        product={data}
                        change={handleChange}
                        prices={prices}
                        setPrices={setPrices}
                    />
                </TabPane>
                <TabPane tab="Imágenes (opcional)" key="4">
                    <PanelImages images={images} setImages={setImages} />
                </TabPane>
            </Tabs>
            <br />
            <Row type="flex" justify="center">
                <Col>
                    <Button type="primary" size="large" icon="save" disabled={!data.name || !data.cost || !data.base_price || !data.tax_type_id || loading} onClick={handleSubmit}>
                        Guardar
                    </Button>
                </Col>
            </Row>
        </Segment>
    )
}

export default ProductsEditContainer
